import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-250">
      <div className="max-w-3xl mx-auto text-center" data-id="element-251">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-252">
          Si eres profesor de yoga,
          <br data-id="element-253" />
          <span className="text-[#B87AFF]" data-id="element-254">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-255">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-256">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-257">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-258">
              Pierdes todos los domingos buscando secuencias y el lunes llegas
              con algo improvisado
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-259">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-260">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-261">
              Posturas complejas (inversiones, equilibrios de brazos,
              extensiones) sin progresión ni material diferenciado por nivel
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-262">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-263">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-264">
              El 70% de los alumnos abandona antes del año y no sabes cómo
              prevenirlo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-265">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-266">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-267">
              Talleres y muestras de fin de año organizados en caos, sin guiones
              ni plan
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-268">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-269">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-270">
              No puedes justificar un aumento de precio porque no tienes un
              sistema profesional visible
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-271">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-272">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-273">
              Siempre las mismas correcciones improvisadas, sin método claro que
              te respalde
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-274">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-275">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-276">
              Alumnos de distintos niveles en la misma clase sin herramientas
              para adaptar
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-277">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-278">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-279">
              Savasana y meditación siempre iguales porque no tienes guiones
              preparados
            </p>
          </div>
        </div>

        <p className="text-[#B87AFF] text-2xl sm:text-3xl font-black mb-8" data-id="element-280">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Violet divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#B87AFF] to-transparent w-full" data-id="element-281" />
      </div>
    </section>;
}